import React from "react";
import { Skeleton } from "../../global/Skeleton/Skeleton";

const WinesTopSkeleton = () => {
  return (
    <>
      <Skeleton
        className="mb-10 mt-6 xs:w-full sm:w-full md:w-full lg:w-3/4 mx-auto max-w-[100%]"
        titleLineStyle="w-[0px]"
      />
      <div className="mb-10 mt-6 xs:w-full sm:w-full md:w-full lg:w-3/4 mx-auto">
        <table className="w-full border border-gray-200">
          <thead>
            <tr className="bg-gray-100 text-left">
              <th className="p-3 border-b w-10">
                <span className="sr-only">Expand row</span>
              </th>
              <th className="p-3 border-b w-16">Rank</th>
              <th className="p-3 border-b w-3/5">Wine</th>
              <th className="p-3 border-b w-16">Score</th>
              <th className="p-3 border-b w-16">Price</th>
            </tr>
          </thead>
          <tbody>
            {[...Array(5)].map((_, idx) => (
              <tr key={idx}>
                <td className="p-3 border-b">
                  <Skeleton lines={1} titleLineStyle="w-[0px]" />
                </td>
                <td className="p-3 border-b">
                  <Skeleton lines={1} titleLineStyle="w-[0px]" />
                </td>
                <td className="p-3 border-b">
                  <Skeleton lines={1} titleLineStyle="w-[0px]" />
                </td>
                <td className="p-3 border-b">
                  <Skeleton lines={1} titleLineStyle="w-[0px]" />
                </td>
                <td className="p-3 border-b">
                  <Skeleton lines={1} titleLineStyle="w-[0px]" />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default WinesTopSkeleton;
